import { GALLERY_LOADING_END } from "../actions/types";
import { GALLERY_LOADING } from "../actions/types";
import { GET_GALLERY } from "../actions/types";

const initialState = {
  gallery: [],
  loading: false,
};

export default function galleryReducer(state = initialState, action) {
  switch (action.type) {
    case GET_GALLERY:
      return {
        ...state,
        gallery: action.gallery,
      };
    case GALLERY_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GALLERY_LOADING_END:
      return {
        ...state,
        loading: false,
      };
    default:
      return {
        ...state,
      };
  }
}
